export default __webpack_public_path__ + "static/dogfriendly-bfd9494fd1c1e2273836fc74dc1f0175.png";